import DefaultValidation from "@/services/validations/DefaultValidation";
import { validateCnpj, validatePhone, isNull } from "@/functions/Util";

export default class TransportadoraValidation extends DefaultValidation{

  constructor(msgs) {
    super(msgs);
  }

  validate(model, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (isNull(model.nome)) {
      refs.nomeInput.focusedOut = true;
      validated = false;
    }

    if (isNull(model.idtransportadoraerp)) {
        refs.idErpInput.focusedOut = true;
        validated = false;
      }
    
    if (isNull(model.cnpj)||(!isNull(model.cnpj)&&!validateCnpj(model.cnpj))) {
      refs.cnpjInput.focusedOut = true;
      validated = false;
    }

    if (!isNull(model.telefone)&&!validatePhone(model.telefone)&&!validatePhone(model.telefone)) {
      refs.telefoneInput.focusedOut = true;
      validated = false;
    }

    return validated;
  }
}